module.exports = __webpack_public_path__ + "static/media/iProgressLogin_1920_7cblock.ad70e853.jpg";